module.exports = require('./dist/init');
